<template>
  <div :class="[design ? null : 'wysiwyg', b({ paddingTop, paddingBottom, design })]">
    <slot></slot>
  </div>
</template>

<script>
  import designMixin from '@/mixins/design.js';

  /**
   * SSR only!
   *
   * Renders a CMS component which supports native text elements (p, ul, ol, h1-h4, ...)
   */
  export default {
    name: 'c-cms-wysiwyg',

    // components: {},
    mixins: [designMixin],

    props: {
      /**
       * Overrides the padding top.
       */
      paddingTop: {
        type: String,
        default: '',
        validator(value) {
          return ['', 'none'].includes(value);
        },
      },

      /**
       * Overrides the padding bottom.
       */
      paddingBottom: {
        type: String,
        default: '',
        validator(value) {
          return ['', 'none'].includes(value);
        },
      },
    },
    // data() {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  // TODO: This needs to be split up.
  @use '@/setup/scss-v2/component' as *;

  // NOTE: For old design wysiwyg styles see '@/setup/scss/_global.scss'

  .c-cms-wysiwyg--design-design2 {
    font-family: var(--fontstack-display);

    h2,
    h3,
    h4 {
      @extend %hyphens;

      color: color(--typography-heading-color);
    }

    h2 {
      @include font-headline--large();
    }

    h3 {
      @include font-headline--medium();
    }

    h2,
    h3 {
      margin-bottom: 30px;
    }

    h4 {
      @include font-headline--small();

      margin-bottom: 20px;
    }

    * + {
      h2,
      h3,
      h4 {
        margin-top: 50px;
      }
    }

    ul {
      padding: 0 0 0 20px;
    }

    ol {
      display: table;
      padding: 0;
      counter-reset: sorted-list;

      li {
        display: table-row;
        counter-increment: sorted-list;

        &::before {
          display: table-cell;
          content: counter(sorted-list) '.';
          padding-right: 10px;
          text-align: right;
        }
      }
    }

    p,
    ul,
    ol {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    b,
    strong {
      font-weight: $font-weight-medium;
    }

    table {
      display: block; // Forces scrollbar support.
      width: 100%;
      overflow-x: auto;

      td {
        padding: 5px 10px 5px 0;
        vertical-align: top;

        @include media(md) {
          padding-right: 20px;
        }

        &:last-child {
          padding-right: 0;
        }
      }
    }

    .typo--body-xlarge {
      @include font-body--xlarge();
    }

    .typo--body-large {
      @include font-body--large();
    }

    .typo--body-big {
      @include font-body--big();
    }

    .typo--body-medium {
      @include font-body--medium();
    }

    .typo--body--small {
      @include font-body--small();
    }

    .typo--legal {
      @include font-label--medium();
    }
  }
</style>
